import firebase from "firebase/app";
import { useMemo, useEffect, useState } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore";
export function useDocumentWithDependencies<T, Dependencies = {}>(
  dependencies: Dependencies,
  docRef: (dependencies: Dependencies) => firebase.firestore.DocumentReference,
  options?:
    | {
        idField?: string | undefined;
        snapshotListenOptions?:
          | firebase.firestore.SnapshotListenOptions
          | undefined;
      }
    | undefined
): [T | undefined, boolean, Error | undefined] {
  const [lastResolveDependencies, setLastResolveDependencies] = useState(false);
  const resolveDependencies = useMemo(() => {
    const unResolveDependencies = Object.keys(dependencies).filter(
      (key) => dependencies[key] === undefined || dependencies[key] === null
    );
    return unResolveDependencies.length === 0;
  }, [dependencies]);
  useEffect(() => {
    setLastResolveDependencies(resolveDependencies);
  }, [resolveDependencies, lastResolveDependencies]);
  const prepareLoading = !lastResolveDependencies && resolveDependencies;
  // const [prepareLoading, setPrepareLoading] = useState(false);
  const [data, dataLoading, dataError] = useDocumentData<T>(
    resolveDependencies && docRef(dependencies),
    options
  );

  /**
   * dataLoadingがtrueになるのが、依存が解決した次のタイミングのため
   * 依存解決時にpreventMissingをtrueにして、dataLoadingがtrueになったらpreventMissingをfalseにする
   */
  // const [preventMissLoading, setPreventMissLoading] = useState(false);
  // useEffect(() => {
  //   if (dataLoading) {
  //     setPreventMissLoading(false);
  //   }
  // }, [dataLoading]);
  // console.log(
  //   `==================================== ${JSON.stringify(dependencies)}`
  // );
  // console.log(`dataLoading: ${dataLoading}`);
  // console.log(`prevent: ${preventMissLoading}`);
  // console.log(`resolveDependencies: ${resolveDependencies}`);
  // console.log(
  //   `result: ${!(resolveDependencies && !dataLoading && !prepareLoading)};`
  // );
  return [data, !(resolveDependencies && !dataLoading && !prepareLoading), dataError];
}
